import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import { getProductBypartner, updateProductPartnerAPI } from "./endpoints";

function* getProductsSaga(action) {
  try {
    yield put(commonActions.setLoading(true));

    const _api = yield call(getProductBypartner, action.payload);

    yield put(actions.setProductsByPartner(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}


function* updateProductPartnerSaga(action) {
  try {
    const _api = yield call(updateProductPartnerAPI, action.payload);
    
    if (_api?.data?.success) {
     
      let partnerId = "";
      if (action.payload?.partnerSK) {
        partnerId = action.payload?.partnerSK;
      }
      const param = { eanCode: "", partnerSK: partnerId };
      yield put(actions.getProductsByPartner(param));
      yield put(
        commonActions.setAlert({
          message: "Product Updated Successfully",
          alertType: "success",
          showToast: true,
        })
      );
    }
  } catch (error) {
    yield put(
      commonActions.setAlert({
        message: error.message || "Update Product Failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(actions.setEditProductLoader(false));
    console.log(error);
  }
}

export function* withSellableProductsSaga() {
  yield all([
    takeEvery(actionTypes.GET_PRODUCTS_BY_PARTNER, getProductsSaga),
    takeEvery(actionTypes.UPDATE_PRODUCTS_BY_PARTNER, updateProductPartnerSaga),
  ]);
}
